// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1onFc","footer":"ModalInfo_footer__1ZVQu"};